import React, { useState, useEffect } from "react";
import styled from "styled-components";
import * as moment from "moment";
import { TextField, Button } from "@material-ui/core";
import DatePicker from "react-datepicker";
import Switch from "react-switch";

export default function ViewBill(props) {
  return (
    <>
      <Section>
        <div className="view__acc_container">
          <div className="view__filterbox__container">
            <div className="view__filterdate__container">



              <div>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    props.onHandleSearchDate();
                  }}
                >
                  <i className="fa fa-search"></i>{" "}
                </Button>
              </div>
              <div>
                <TextField
                  className="txtfld"
                  id="outlined-basic"
                  variant="outlined"
                  fullWidth={false}
                  onChange={(e) => {
                    props.onHandleSearch(e.target.value);
                  }}
                  value={props.search}
                  placeholder="Search"
                  style={{ backgroundColor: "white" }}
                />
              </div>

              <div>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    props.onBillFetch();
                  }}
                  disabled={props.isbill ? false : true}
                >
                  {" "}
                  Bill
                </Button>
              </div>
            </div>

            <div className="view__filtersearch__container">
              <TextField
                className="txtfld"
                id="outlined-basic"
                variant="outlined"
                fullWidth={false}
                onChange={(e) => {
                  props.onHandleSearch(e.target.value);
                }}
                value={props.search}
                placeholder="Search"
                style={{ backgroundColor: "white" }}
              />
            </div>
          </div>

          <div
            className="table-responsive"
          // style={{ marginTop: "-0.1rem", overflow: "auto", height: "500px" }}
          >
            <table className="table table-bordered table-responsive-sm">
              <thead style={{ backgroundColor: "#00b894", color: "#ffffff" }}>
                <tr >
                  <th>S.No</th>

                  <th>Entry_Date</th>
                  <th>__Bill_Number__</th>
                  <th>Customer Name</th>
                  <th>Phone</th>
                  <th>Place</th>
                  <th>Brand</th>
                  <th>Model Number</th>
                  <th>Frame Type</th>
                  <th>Frame Color</th>
                  <th>Frame Size</th>

                  <th>Quantity</th>
                  <th>Lens Rate</th>
                  <th>Frame Rate</th>
                  <th>Advance</th>
                  <th>Amount</th>
                  <th>Balance</th>
                  <th>PayMode</th>
                  {/* <th></th>
                  <th></th> */}
                </tr>
              </thead>
              <tbody
                style={{ maxHeight: "200px", overflowY: "auto", width: "100%" }}
              >
                {props.bills.length > 0 ? (
                  props.bills.map((sal, index) => {
                    return (
                      <tr
                        style={{ backgroundColor: sal.pay_mode ? '#7bed9f' : '' }}
                        key={index}
                        onClick={() => {
                          props.onHandleEditChange(sal);
                        }}

                      >
                        <td> {index + 1} </td>

                        <td> {moment(sal.entry_date).format("DD-MM-YYYY")} </td>
                        <td> {sal.bill_num} </td>
                        <td> {sal.cus_name} </td>
                        <td> {sal.phone} </td>
                        <td> {sal.place} </td>
                        <td> {sal.brand} </td>
                        <td> {sal.model_number} </td>
                        <td> {sal.frame_type} </td>
                        <td> {sal.frame_color} </td>
                        <td> {sal.frame_size} </td>

                        <td> {sal.quantity} </td>
                        <td> {sal.lens_rate}</td>
                        <td> {sal.frame_rate} </td>
                        <td>
                          {sal.advance} <br /> {sal.adv_pay_mode}
                        </td>
                        {/* style={{ backgroundColor: sal.pay_mode.length > 0 ? 'pink' : '' }} */}
                        <td>{sal.amount}</td>
                        <td >
                          {sal.pay_mode != null ? '0' : (sal.amount - sal.advance)}
                          {/* {sal.pay_mode.length > 0 ? <p>{sal.amount - sal.advance}</p> : 0}  */}
                          <br /> {sal.pay_mode}
                        </td>

                        <td
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            props.onHandleUpdate(sal);
                          }}
                        >
                          <i className="fa fa-refresh"></i>
                        </td>
                        {/* <td>
                          <Switch
                            onChange={(val) => {
                              props.onHandleSwitchChange(sal, val);
                            }}
                            checked={sal.bill_checked === 1 ? true : false}
                          />
                        </td> */}
                        {/* <td style={{ cursor: "pointer" }}>
                          <i
                            className="fa fa-trash"
                            onClick={() => {
                              props.onHandleDelete(sal);
                            }}
                          ></i>
                        </td> */}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td>No Data</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Section >
    </>
  );
}

const Section = styled.section`
  .view__acc_container {
    margin: 0px 0px;
    padding-left: 8rem;
  }

  .view__filterbox__container {
    margin: 0px auto;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    gap: 1rem;
    padding: 0.5rem;
    background-color: #b8e994;
  }
  .view__filterdate__container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    flex: 0.7;
  }
  .view__filtersearch__container {
    flex: 0.3;
    text-align: center;
  }

  @media screen and (min-width: 280px) and (max-width: 720px) {
    .view__filterbox__container {
      display: flex;
      flex-direction: column;
    }
    .view__filterdate__container {
      display: flex;
      flex-direction: column;
    }
  }
`;
